import { useParams } from 'react-router-dom'

export function useLangPrefix() {
  const { lang } = useParams()
  const safe = lang === 'vi' || lang === 'en' ? lang : 'en'
  return { prefix: `/${safe}`, lang: safe }
}
